exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spacer{margin-top:20px}input.use-multiple-download{margin-top:-2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/download/views/DownloadOptionsModalView.css
// module id = 1979
// module chunks = 0